<template>
    <div class="dropdown">
      <input v-if="Object.keys(selectedItem).length === 0" ref="dropdowninput" v-model="inputValue" class="dropdown-input" type="text" placeholder="Search..." />
        <div v-else @click="resetSelection" class="dropdown-selected">
          {{ selectedItem.name }}
        </div>
        <div v-if="apiLoaded && inputValue" class="dropdown-list">
          <div v-show="itemVisible(item)" v-for="item in itemList" :key="item.name" class="dropdown-itm">
            <a :href="item.url">
              [<b>{{ item.type }}</b>]
           {{ item.title }}

          </a>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            inputValue: '',
            itemList: [],
            apiLoaded: false,
            selectedItem: {},
            requests: [],
            request: null,
        };
    },
    watch: {
      inputValue(after, before) {

          if(after != '' && after.length > 2){
            this.getList();
          }
        }
    },
    methods: {
        resetSelection () {
          this.selectedItem = {}
          this.$nextTick( () => this.$refs.dropdowninput.focus() )
          this.$emit('on-item-reset')
        },
        selectItem (theItem) {
          this.selectedItem = theItem
          this.inputValue = ''
          this.$emit('on-item-selected', theItem)
        },
        itemVisible (item) {
          let currentName = item.title.toLowerCase()
          let currentInput = this.inputValue.toLowerCase()
          // return currentName.includes(currentInput)
          return currentName
        },
        getList() {
          if (this.request) this.cancel();
          this.makeRequest();
        },

        cancel() {
          this.request.cancel();
          this.clearOldRequest("Cancelled");
        },
        makeRequest () {
          const axiosSource = axios.CancelToken.source();
          this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
           axios.get('/search', {
             params: { query: this.inputValue } ,
             cancelToken: axiosSource.token
          })
          .then( response => {
            this.clearOldRequest("Success");
            this.itemList = response.data
            this.apiLoaded = true
          }).catch( error => {
            // console.error(error);
          })
        },

        clearOldRequest(msg) {
          this.request.msg = msg;
          this.requests.push(this.request);
          this.request = null;
        }
    }
}
</script>
